import React, { useContext, useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import Offcanvas from "react-bootstrap/Offcanvas";
import Card from "react-bootstrap/Card";
import ModalSave from "../../../common/ModalSave";
import { CancelButton, SaveButton } from "../../../common/Button";
import { Container, Row, Col, Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import { Select2Data } from "../../../../utils/common";

library.add(fas);

const AddOffCanvance = (props) => {
  const { postData, getData, IMG_URL } = useContext(Context);
  const id = props.id;

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
    watch,
    control,
  } = useForm();

  const [showModal, setShowModal] = useState({ code: 0, message: "" });
  const [iconPreview, setIconPreview] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null); // ✅ keep real file here

  // 🔹 Handle file change and preview
  const handleFileChange = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      setSelectedFile(file);
      setIconPreview(URL.createObjectURL(file));
    }
  };

  // 🔹 Fetch existing data when editing
  const GetEditData = async () => {
    if (!id) return;

    const response = await getData(`/masters/bank-detail/${id}`);

    if (response?.data) {
      let data = response.data;

      const stateIds = data.state_id?.map((item) => item.value) || [];

      reset({
        ...data,
        state_id: stateIds,
      });

      if (stateIds.length) {
        GetAllCity(stateIds);
      }

      if (data.icon) {
        setIconPreview(IMG_URL + data.icon);
      }
    }
  };

  useEffect(() => {
    GetEditData();
  }, [id]);

  // 🔹 Handle submit using FormData
  const onSubmit = async (data) => {
    try {
      const formData = new FormData();

      // ✅ append all normal fields except specific ones
      for (const key in data) {
        if (
          key !== "icon" &&
          key !== "selected_districts" &&
          key !== "state_id" &&
          key !== "payment_type_id" &&
          data[key] !== undefined &&
          data[key] !== null
        ) {
          formData.append(key, data[key]);
        }
      }

      // ✅ file
      if (selectedFile) {
        formData.append("icon", selectedFile);
      }

      // ✅ arrays → stringify
      if (data?.selected_districts?.length) {
        formData.append(
          "selected_districts",
          JSON.stringify(data.selected_districts),
        );
      }

      if (data?.state_id?.length) {
        formData.append("state_id", JSON.stringify(data.state_id));
      }

      if (data?.payment_type_id) {
        formData.append("payment_type_id", data?.payment_type_id?.value);
      }

      const response = id
        ? await postData(`/masters/bank-detail/${id}`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          })
        : await postData(`/masters/bank-detail`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

      setShowModal({ code: response.code, message: response.message });

      setTimeout(() => {
        setShowModal({ code: 0, message: "" });
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  const errorStyle = { color: "red", marginLeft: "5px" };

  const [states, setStates] = useState([]);
  const GetAllState = async () => {
    const response = await getData("/without-login/masters/all-states");

    if (response?.success) {
      setStates(await Select2Data(response?.data, "state_id"));
    }
  };

  const [cities, setCity] = useState([]);
  const GetAllCity = async (stateIds) => {
    try {
      const response = await getData(
        `/without-login/masters/all-cities?state_id=${stateIds.join(",")}`,
      );

      setCity(response?.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    GetAllState();
  }, []);

  const handleSelectAll = (e, cityIdx) => {
    // Get all district IDs for the current city
    const selectedDistricts = cities[cityIdx]?.cities?.map(
      (district) => district.id,
    );

    // Get current selected districts in the form
    const currentSelectedDistricts = watch("selected_districts") || [];

    if (e.target.checked) {
      // If "Select All" is checked, add all districts for this city to the selected list
      const newSelectedDistricts = [
        ...new Set([...currentSelectedDistricts, ...selectedDistricts]), // Add only new districts (no duplicates)
      ];
      setValue("selected_districts", newSelectedDistricts); // Update form state
    } else {
      // If "Select All" is unchecked, remove all districts for this city from the selected list
      const newSelectedDistricts = currentSelectedDistricts.filter(
        (districtId) => !selectedDistricts.includes(districtId),
      );
      setValue("selected_districts", newSelectedDistricts); // Update form state
    }
  };

  const handleDistrictChange = (e, districtId) => {
    const currentSelectedDistricts = watch("selected_districts") || [];

    if (e.target.checked) {
      // Add the district ID to the selected districts array
      const newSelectedDistricts = [
        ...new Set([...currentSelectedDistricts, districtId]),
      ];
      setValue("selected_districts", newSelectedDistricts);
    } else {
      // Remove the district ID from the selected districts array
      const newSelectedDistricts = currentSelectedDistricts.filter(
        (id) => id !== districtId,
      );
      setValue("selected_districts", newSelectedDistricts);
    }
  };

  const type = [
    { value: "UPI", label: "UPI" },
    { value: "Bank", label: "Bank" },
  ];
  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement="end"
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton />
        <Offcanvas.Body>
          <Card className="shadow-lg p-3 mb-5 bg-white rounded">
            <Card.Body>
              <Card.Title>{id ? "Edit Bank" : "Add Bank"}</Card.Title>
              <hr />
              <Container>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Row>
                    <Col md={12}>
                      <Container>
                        <Row>
                          <Col xxl={12} xl={12} md={12}>
                            <Form className="AppSetupclass">
                              <Row>
                                <Col
                                  lg={12}
                                  md={12}
                                  className="mx-auto Add-content"
                                >
                                  <div className="row">
                                    <div className="col-lg-8 mb-3">
                                      <Form.Group>
                                        <Form.Label column sm={3}>
                                          States{" "}
                                        </Form.Label>

                                        {/* <Controller
                                          name="state_id"
                                          control={control}
                                          rules={{ required: "Select State" }}
                                          render={({ field }) => (
                                            <Select
                                              {...field}
                                              isMulti
                                              options={states}
                                              value={states?.filter((option) =>
                                                field.value?.includes(
                                                  option.value,
                                                ),
                                              )}
                                              onChange={(selectedOptions) => {
                                                const values =
                                                  selectedOptions.map(
                                                    (opt) => opt.value,
                                                  );

                                                field.onChange(values);

                                                GetAllCity(values);
                                              }}
                                              styles={{
                                                control: (base) => ({
                                                  ...base,
                                                  borderColor: errors.state_id
                                                    ? "red"
                                                    : base.borderColor,
                                                }),
                                              }}
                                            />
                                          )}
                                        /> */}

                                        <Controller
                                          name="state_id"
                                          control={control}
                                          rules={{ required: "Select States" }}
                                          render={({ field }) => (
                                            <Select
                                              isMulti
                                              options={states}
                                              // ✅ show selected values
                                              value={states.filter((option) =>
                                                field.value?.includes(
                                                  option.value,
                                                ),
                                              )}
                                              // ✅ handle change
                                              onChange={(selectedOptions) => {
                                                const values = selectedOptions
                                                  ? selectedOptions.map(
                                                      (opt) => opt.value,
                                                    )
                                                  : [];

                                                field.onChange(values); // ✅ ONLY ONCE

                                                GetAllCity(values); // ✅ API call
                                              }}
                                              styles={{
                                                control: (base) => ({
                                                  ...base,
                                                  borderColor: errors.state_id
                                                    ? "red"
                                                    : base.borderColor,
                                                }),
                                              }}
                                            />
                                          )}
                                        />
                                      </Form.Group>
                                    </div>
                                    {cities?.length ? (
                                      <Form.Group className="mb-5">
                                        <Form.Check
                                          type="checkbox"
                                          label="Select All"
                                          style={{ color: "#fff" }}
                                          onChange={(e) =>
                                            cities.forEach((city, idx) =>
                                              handleSelectAll(e, idx),
                                            )
                                          }
                                        />
                                      </Form.Group>
                                    ) : (
                                      <></>
                                    )}
                                    {cities.length > 0 &&
                                      cities?.map((val) => (
                                        <>
                                          {" "}
                                          <p className="state_text">
                                            {val?.state_name}
                                          </p>
                                          <div className="row mb-5">
                                            {val?.cities?.map((val1) => (
                                              <div className="col-lg-3">
                                                <Form.Group>
                                                  <Form.Check
                                                    id={`${val?.id}${val1?.id}`}
                                                    type="checkbox"
                                                    label={val1?.name}
                                                    value={val1?.id}
                                                    style={{ color: "#fff" }}
                                                    checked={watch(
                                                      "selected_districts",
                                                    )?.includes(val1.id)}
                                                    onChange={(e) =>
                                                      handleDistrictChange(
                                                        e,
                                                        val1.id,
                                                      )
                                                    }
                                                  />
                                                </Form.Group>
                                              </div>
                                            ))}
                                          </div>
                                        </>
                                      ))}

                                    <div className="row">
                                      <div className="col-lg-8 mb-3">
                                        <Form.Group>
                                          <Form.Label column sm={3}>
                                            Payment Type{" "}
                                          </Form.Label>

                                          <Controller
                                            name="payment_type_id" // name of the field
                                            {...register("payment_type_id", {
                                              required: "Select Country",
                                            })}
                                            control={control}
                                            render={({ field }) => (
                                              <Select
                                                styles={{
                                                  control: (baseStyles) => ({
                                                    ...baseStyles,
                                                    borderColor:
                                                      errors.payment_type_id
                                                        ? "red"
                                                        : baseStyles,
                                                  }),
                                                }}
                                                {...field}
                                                options={type}
                                              />
                                            )}
                                          />
                                          {errors.payment_type_id && (
                                            <span className="text-danger">
                                              {errors.payment_type_id.message}
                                            </span>
                                          )}
                                        </Form.Group>

                                        {watch("payment_type_id")?.value ===
                                          "UPI" && (
                                          <>
                                            <Form.Group>
                                              <Form.Label column sm={3}>
                                                UPI Id{" "}
                                              </Form.Label>

                                              <Form.Control
                                                type="text"
                                                name="upi_id"
                                                placeholder="UPI ID"
                                                {...register("upi_id", {
                                                  required:
                                                    "UPI ID is required",
                                                })}
                                              />
                                              {errors.upi_id && (
                                                <span className="text-danger">
                                                  {errors.upi_id.message}
                                                </span>
                                              )}
                                            </Form.Group>{" "}
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>

                                  {watch("payment_type_id")?.value ===
                                    "Bank" && (
                                    <>
                                      <Row>
                                        <h5>
                                          <b>Bank Details</b>
                                        </h5>

                                        {/* Bank Name */}

                                        <Col md={3}>
                                          <Form.Label>Account Name</Form.Label>
                                          <Form.Control
                                            type="text"
                                            {...register("holder_name", {
                                              required:
                                                "Account Name is required",
                                            })}
                                            className={`form-control ${errors.holder_name ? "is-invalid" : ""}`}
                                            placeholder="Account Name"
                                          />
                                          {errors.holder_name && (
                                            <span style={errorStyle}>
                                              {errors.holder_name.message}
                                            </span>
                                          )}
                                        </Col>
                                        <Col md={3}>
                                          <Form.Label>Bank Name</Form.Label>
                                          <Form.Control
                                            type="text"
                                            {...register("bank_name", {
                                              required: "Bank Name is required",
                                            })}
                                            className={`form-control ${errors.bank_name ? "is-invalid" : ""}`}
                                            placeholder="Bank Name"
                                          />
                                          {errors.bank_name && (
                                            <span style={errorStyle}>
                                              {errors.bank_name.message}
                                            </span>
                                          )}
                                        </Col>

                                        {/* Firm Name */}
                                        <Col md={3}>
                                          <Form.Label>Branch</Form.Label>
                                          <Form.Control
                                            type="text"
                                            {...register("firm_name", {
                                              required: "Branch is required",
                                            })}
                                            className={`form-control ${errors.firm_name ? "is-invalid" : ""}`}
                                            placeholder="Branch"
                                          />
                                          {errors.firm_name && (
                                            <span style={errorStyle}>
                                              {errors.firm_name.message}
                                            </span>
                                          )}
                                        </Col>

                                        {/* A/c No */}
                                        <Col md={3}>
                                          <Form.Label>A/c No</Form.Label>
                                          <Form.Control
                                            type="number"
                                            {...register("ac_no", {
                                              required: "A/c No is required",
                                            })}
                                            className={`form-control ${errors.ac_no ? "is-invalid" : ""}`}
                                            placeholder="A/c No"
                                          />
                                          {errors.ac_no && (
                                            <span style={errorStyle}>
                                              {errors.ac_no.message}
                                            </span>
                                          )}
                                        </Col>

                                        {/* IFSC Code */}
                                        <Col md={3}>
                                          <Form.Label>IFSC Code</Form.Label>
                                          <Form.Control
                                            type="text"
                                            {...register("ifsc_code", {
                                              required: "IFSC Code is required",
                                            })}
                                            className={`form-control ${errors.ifsc_code ? "is-invalid" : ""}`}
                                            placeholder="IFSC Code"
                                          />
                                          {errors.ifsc_code && (
                                            <span style={errorStyle}>
                                              {errors.ifsc_code.message}
                                            </span>
                                          )}
                                        </Col>

                                        {/* Text Color */}
                                        <Col md={3}>
                                          <Form.Label>Text Color</Form.Label>
                                          <Form.Control
                                            type="color"
                                            {...register("text_color")}
                                            className="form-control form-control-color"
                                          />
                                        </Col>

                                        {/* Background Color */}
                                        <Col md={3}>
                                          <Form.Label>
                                            Background Color
                                          </Form.Label>
                                          <Form.Control
                                            type="color"
                                            {...register("background_color")}
                                            className="form-control form-control-color"
                                          />
                                        </Col>

                                        {/* Icon Upload */}
                                        {/* <Col md={3}>
                                          <Form.Label>Icon</Form.Label>
                                          <Form.Control
                                            type="file"
                                            accept="image/*"
                                            onChange={handleFileChange}
                                          />
                                          {iconPreview && (
                                            <div className="mt-2 text-center">
                                              <img
                                                src={iconPreview}
                                                alt="Preview"
                                                style={{
                                                  width: 60,
                                                  height: 60,
                                                  borderRadius: "50%",
                                                }}
                                              />
                                            </div>
                                          )}
                                        </Col> */}
                                      </Row>
                                    </>
                                  )}
                                  <hr />

                                  <Row className="pb-3">
                                    <div className="d-flex justify-content-center">
                                      <Link>
                                        <CancelButton
                                          name="cancel"
                                          handleClose={props.handleClose}
                                        />
                                      </Link>
                                      <SaveButton
                                        name="save"
                                        handleSubmit={handleSubmit(onSubmit)}
                                      />
                                    </div>
                                  </Row>
                                </Col>
                              </Row>
                            </Form>
                          </Col>
                        </Row>
                      </Container>
                    </Col>
                  </Row>
                </form>
              </Container>
            </Card.Body>
          </Card>
        </Offcanvas.Body>
      </Offcanvas>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default AddOffCanvance;
